import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';
import { Subscription } from 'rxjs';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-desk-devices-card',
  templateUrl: './turns-desk-devices-card.component.html',
  styleUrls: ['./turns-desk-devices-card.component.scss']
})
export class TurnsDeskDevicesCardComponent implements OnInit, OnDestroy {

  @Input() internalId;
  @Input() devices: Array<DeviceBasic>;
  @Input() assignedDevices: Array<DeviceBasic>;
  devicesInternalIdSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public outputEventReceiver(selectedDevices)  {
    const devicesInternalId = new Array();
    for (const d of selectedDevices) {
      devicesInternalId.push(d[1]._data);
    }
    this.devicesInternalIdSubscription = this.desksTurnsService.saveDeskDevices(this.internalId, devicesInternalId).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
      },
      (error) => {
        this.desksTurnsService.refreshDesk();
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.devicesInternalIdSubscription) { this.devicesInternalIdSubscription.unsubscribe(); }
  }
}
